'use strict';

var _ = require('lodash');
var FaresAverageGridService = function FaresAverageGridService(configurationService, overridesKeyService, overridesSaveService, scenarioConstants) {
  function getDomain(showAverageFaresGrid) {
    return showAverageFaresGrid ? 'MarketClassPOSAverageFare' : 'MarketClassPOSMappedFare';
  }
  function getFilterKeysFromRows(rows, showAverageFaresGrid) {
    var spos = [];
    var classes = [];
    var dateRanges = [];
    var classSposes = [];
    var classesVarName = showAverageFaresGrid ? 'bookingClass' : 'className';
    _.forEach(rows, function (row) {
      spos.push(row.spos);
      classes.push(row[classesVarName]);
      dateRanges.push(prepareRange(row));
      classSposes.push(row[classesVarName] + '_' + row.spos);
    });
    return {
      spos: _.uniq(spos),
      classes: _.uniq(classes),
      dateRanges: _.uniq(dateRanges),
      classSposes: _.uniq(classSposes)
    };
  }
  function prepareRange(row) {
    return row.applicableDateRangeBegin.toISOString() + ',' + row.applicableDateRangeEnd.toISOString();
  }
  function save(data, showAverageFaresGrid) {
    var overrides = [];
    data.forEach(function (row) {
      if (showAverageFaresGrid) {
        row.userFare = isNaN(row.userFare) ? 0 : row.userFare;
      } else {
        row.userMappedFare = isNaN(row.userMappedFare) ? 0 : row.userMappedFare;
      }
      var overrideKey = overridesKeyService.buildOverrideKey(getDomain(showAverageFaresGrid), row);
      var override = _.extend({
        field: 'fare',
        type: 'O',
        value: showAverageFaresGrid ? row.userFare : row.userMappedFare
      }, overrideKey);
      overrides.push(override);
    });
    return overridesSaveService.putOverrides(getDomain(showAverageFaresGrid), {
      userId: configurationService.getUserId(),
      scenario: scenarioConstants.PUBLISHED,
      overrides: overrides
    });
  }
  return {
    getFilterKeysFromRows: getFilterKeysFromRows,
    save: save
  };
};
FaresAverageGridService.$inject = ['ConfigurationService', 'OverridesKeyService', 'OverridesSaveService', 'ScenarioConstants'];
module.exports = FaresAverageGridService;